import { useState } from 'react';

import { enqueueSnackbar } from '../../../../../components/GlobalSnackbar/snackbarStore';
import { usePermissions } from '../../../../../hooks/usePermissions';
import type { ReminderDatabase } from '../../../../../types';
import useCompleteReminder from '../../../../reminders/api/useCompleteReminder';

export type UseReminderCardProps = {
  reminder: ReminderDatabase;
  displayProvider?: boolean;
  displaySubject?: boolean;
};

export function canManageReminder(isCompleted?: boolean | null, isAdmin?: boolean | null): boolean {
  return !isCompleted && Boolean(isAdmin);
}

export default function useReminderCard(props: UseReminderCardProps) {
  const { isAdmin } = usePermissions();
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isCreateEventModalOpen, setIsCreateEventModalOpen] = useState(false);

  const {
    mutateAsync: completeReminder,
    isPending,
    error: completeReminderError,
  } = useCompleteReminder();

  async function handleCompleteReminder(successMessage: string) {
    await completeReminder(props.reminder.id);
    enqueueSnackbar(successMessage, 'success');
  }

  function handleOpenUpdateModal() {
    setIsUpdateModalOpen(true);
  }

  function handleCloseUpdateModal() {
    setIsUpdateModalOpen(false);
  }

  function handleOpenDeleteModal() {
    setIsDeleteModalOpen(true);
  }

  function handleCloseDeleteModal() {
    setIsDeleteModalOpen(false);
  }

  function handleOpenCreateEventModal() {
    setIsCreateEventModalOpen(true);
  }

  function handleCloseCreateEventModal() {
    setIsCreateEventModalOpen(false);
  }

  async function handleCreateEventSuccess() {
    await handleCompleteReminder('Rendez-vous créé et rappel marqué comme terminé.');
  }

  const canManage = canManageReminder(props.reminder.is_completed, isAdmin);

  return {
    isAdmin,
    canManage,
    isUpdateModalOpen,
    isDeleteModalOpen,
    isCreateEventModalOpen,
    isPending,
    completeReminderError,
    handleCompleteReminder,
    handleOpenUpdateModal,
    handleCloseUpdateModal,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    handleOpenCreateEventModal,
    handleCloseCreateEventModal,
    handleCreateEventSuccess,
  };
}
